<template>
  <div>
    <!--顶部按钮-->
    <div class="app-container">
      <!-- <vxe-button class="el-icon-circle-plus-outline" status="primary" @click="goAdd">新增</vxe-button> -->
      <!-- <vxe-button class="el-icon-upload" status="primary" @click="uploadFun">导入</vxe-button> -->
      <div style="height: 30px">
        <vxe-button @click="deriveFun" v-auth="`EXPORT`">导出</vxe-button>
        <div style="float: right; color: #848484; display: flex; line-height: 28px">
          <div v-if="!showdiv">
            <el-input v-model="queryCondition.actCode" placeholder="活动提报编码" clearable style="width: 150px; margin-right: 1rem" @keyup.enter.native="queryByPage()" />
          <!-- <el-input v-model="queryCondition.actType" placeholder="活动类型" clearable style="width: 150px; margin-right: 1rem" @keyup.enter.native="queryByPage()" /> -->
          </div>
          <div>
            <vxe-button v-if="!showdiv" status="primary" @click="queryByPage(1)">搜索</vxe-button>
            <vxe-button v-if="!showdiv" type="info" class="filter-search-item" @click="resetForm">重置</vxe-button>
            <vxe-button type="warning" @click="cb">
              {{ showdiv ? '收起' : '更多选项' }}
            </vxe-button>
          </div>
        </div>
      </div>
      <!--筛选拓展-->
      <div style="margin-top: 10px">
        <el-collapse-transition>
          <div v-if="showdiv">
            <div v-if="showdiv">
              <el-form label-width="110px" class="UniformCss">
                <el-row :gutter="5">
                  <el-col :span="4">
                    <a-form-model-item label="活动提报编码">
                      <el-input v-model="queryCondition.actCode" clearable placeholder="活动编码" />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="活动名称">
                      <el-input v-model="queryCondition.planApplyName" clearable placeholder="活动名称" />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="经理部">
                      <el-input v-model="queryCondition.regionName" clearable placeholder="经理部" />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="经销商">
                      <el-input v-model="queryCondition.dealerName" clearable placeholder="经销商" />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="预算类型">
                      <el-input v-model="queryCondition.budgetTypeName" clearable placeholder="预算类型" />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="客户名称">
                      <el-input v-model="queryCondition.customerName" clearable placeholder="客户名称" />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="手机号">
                      <el-input v-model="queryCondition.mobile" clearable placeholder="手机号" />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="意向品系">
                      <el-input v-model="queryCondition.seriesName" clearable placeholder="请输入品系关键字" />
                    </a-form-model-item>
                  </el-col>
                 <!--
                  <el-col :span="8">
                    <el-form-item label="车系">
                      <el-input v-model="queryCondition.subSeriesName" clearable placeholder="请输入车系关键字" />
                    </el-form-item>
                  </el-col>
                   -->
                  <el-col :span="4">
                    <a-form-model-item label="活动实际开展时间从：">
                      <a-date-picker valueFormat="YYYY-MM-DD" v-model="queryCondition.actualStartTimeStart" picker="date" placeholder="选择日期" />
                    </a-form-model-item>
                  </el-col>
                  <el-col :span="4">
                    <a-form-model-item label="至：">
                      <a-date-picker valueFormat="YYYY-MM-DD" v-model="queryCondition.actualStartTimeEnd" picker="date" placeholder="选择日期"
                                     :picker-options="{ disabledDate: time => time.getTime() < new Date(queryCondition.actualStartTimeStart) - 8.64e7 }" />
                    </a-form-model-item>
                  </el-col>
                </el-row>

              </el-form>
              <br>
              <div slot="footer" style="text-align: center; padding-bottom: 10px">
                <vxe-button type="info" @click="resetForm">重置</vxe-button>
                <vxe-button status="primary" @click="queryByPage(1)">搜索</vxe-button>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
      <!--table列表-->
      <vxe-table
        ref="xTable"
        :loading="listLoading"
        :align="allAlign"
        :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
        border
        show-header-overflow
        show-overflow
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="tableData"
        @sort-change="listSortMethod"
      >
        <vxe-column type="checkbox" width="60" align="center" />
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <vxe-column field="actCode" title="活动提报编码" width="150" />
        <!-- <vxe-column field="actType" title="活动类型" width="120" /> -->
        <vxe-column field="regionName" title="经理部" width="120" />
        <!-- <vxe-column field="dealerName" title="经销商" width="180" /> -->
        <vxe-column field="orgName" title="经销商" width="120" />
        <vxe-column field="planApplyName" title="活动名称" width="120" />
        <vxe-column field="budgetTypeName" title="预算类型" width="120" />
        <vxe-column field="oneLevelName" title="一级来源" width="120" />
        <vxe-column field="twoLevelName" title="二级来源" width="120" />
        <vxe-column field="threeLevelName" title="三级来源" width="120" />
        <vxe-column field="customerName" title="客户名称" width="150" />
        <vxe-column field="mobile" title="手机号" width="150" />
        <!-- <vxe-column field="wechat" title="微信" width="150" />
        <vxe-column field="email" title="邮箱" width="150" />
        <vxe-column field="others" title="其他联系方式" width="150" /> -->
        <vxe-column field="seriesName" title="意向品系" width="150" />
        <!-- <vxe-column field="subSeriesName" title="车系" width="150" />
        <vxe-column field="reservationTime" title="预约试驾时间" width="150" />
        <vxe-column field="intendedDate" title="意向购车时间" width="150" sortable />
        <vxe-column field="type" title="类型" width="150" />
        <vxe-column field="createUser" title="创建人" width="100" />-->
        <vxe-column field="actualStartTime" title="活动实际开展时间" width="150" />
        <vxe-column field="createTime" title="扫码时间" width="150" />
        <!-- <vxe-column field="remark" title="备注" width="150" /> -->
        <vxe-column title="操作" width="100" fixed="right" align="center">
          <template #default="{ row }">
            <div class="operate" style="height:30px">
              <!-- <el-link status="primary" icon="el-icon-edit-outline" @click="editFun(row)">修改</el-link> -->
              <a-button v-auth="`VIEW`" type="link" @click="detailFun(row)">查看</a-button>
              <!-- <a-button type="link" @click="detailFun(row)">查看</a-button> -->
              <!-- <el-link status="primary" icon="el-icon-delete" @click="deleteFun(row)">删除</el-link> -->
            </div>
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        :current-page="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
      />
    </div>
    <!--导入对话框 -->
    <el-dialog title="导入Excel" :visible.sync="uploadDialog" width="22%">
      <div :loading="importLoading" class="faultAdd">
        <div class="model-box">
          <a class="load-buttom" href="/file/活动集客导入模板.xlsx" download><i class="el-icon-download" />下载示例模板</a>
        </div>
        <el-upload ref="upload" class="upload-demo" drag action="" multiple :http-request="upload" :before-upload="uploadBefore" :file-list="fileList">
          <i class="el-icon-upload" />
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">直接导入已填好的Excel列表，仅支持XLS/XLSX</div>
        </el-upload>
        <div v-if="errorList.length>0" class="err-box">
          <el-link icon="el-icon-warning" type="danger">Excel导入出错，请检查错误行，然后将错误行重新导入</el-link>
          <div v-for="item in errorList" :key="item.row">
            <el-link type="danger">第{{ item.row }}行{{ item.error }}</el-link>
          </div>
        </div>
      </div>
    </el-dialog>
    <!--导出对话框 -->
    <el-dialog title="选择导出项" :visible.sync="dialogVisible" width="400px">
      <el-radio-group v-model="ExportItem">
        <el-radio :label="0">导出全部</el-radio>
        <el-radio :label="1">导出当前页</el-radio>
        <el-radio :label="2" :disabled="disabled">导出已选择项</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="dialogVisible = false">取 消</vxe-button>
        <vxe-button status="primary" :loading="outExcelButtonLocading" @click="exportXlsxFun">确 定</vxe-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { actCustomerfindList, deleteActCustomer, exportActCustomer, uploadActCustomer } from '@/api/activityCustomer'
import { outExcel } from '@/utils/Excel/outExcel'

const defaultPagination = {
  total: 0,
  size: 20,
  current: 1
}

export default {
  // 活动集客,
  name: 'ActCustomerList',
  data() {
    return {
      showdiv: false,
      pagination: Object.assign({}, defaultPagination),
      listLoading: false,
      tableData: [],
      allAlign: 'center',
      queryCondition: {},
      // 导出对话框
      dialogVisible: false,
      disabled: true, // 已选择按钮是否禁用
      outExcelButtonLocading: false,
      ExportItem: 0,
      fileList: [],
      errorList: [],
      uploadDialog: false,
      importLoading: false,
      sort: 'create_time desc'
    }
  },

  watch: {},
  created() {
    // 获取表格数据
    this.queryByPage()
  },
  mounted() {},
  methods: {
    //  新增跳转
    goAdd() {
      this.$router.push({ path: `actCustomerDetail/add` })
    },
    deriveFun() {
      this.dialogVisible = true
      // 判断是否选中
      this.disabled = this.$refs.xTable.selection.length < 1
    },
    // 导出表格
    async exportXlsxFun() {
      // 需要导出的数据
      let data = []
      this.outExcelButtonLocading = true
      if (this.ExportItem == 0) {
        if (this.pagination.total > 10000) {
          this.$message.warning('导入' + this.pagination.total + '条，过程可能持续数分钟。')
        }
        let data = { page: 1, limit: this.pagination.total, sort: this.sort, ...this.queryCondition }
        exportActCustomer(data).then(val => {
          this.$exportExcelData(val, `活动集客信息表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
          this.dialogVisible = false
          this.outExcelButtonLocading = false
        })
        return
      } else if (this.ExportItem == 1) {
        data = this.tableData
      } else if (this.ExportItem == 2) {
        data = this.$refs.xTable.selection
      }
      let table = []
      for (var i = 0; i < data.length; i++) {
        var params = {
          活动编码: data[i].actCode,
          活动类型: data[i].actType,
          经理部: data[i].regionName,
          经销商: data[i].orgName,
          活动名称: data[i].planApplyName,
          预算类型: data[i].budgetTypeName,
          一级来源: data[i].oneLevelName,
          二级来源: data[i].twoLevelName,
          三级来源: data[i].threeLevelName,
          客户名称: data[i].customerName,
          手机号: data[i].mobile,
          意向品系: data[i].seriesName,
          活动实际开展时间: data[i].actualStartTime,
          扫码时间: data[i].createTime,
        }
        table[i] = params
      }
      const wch = [15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 25, 25]
      outExcel('活动集客信息表', table, wch)
      // 关闭弹窗
      this.dialogVisible = false
      this.outExcelButtonLocading = false
    },
    // 导入弹窗
    uploadFun() {
      this.uploadDialog = true
    },
    // 上传前对文件的大小的判断
    uploadBefore(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message('只能上传后缀是.xlsx或者.xls的文件')
        return false
      }

      if (size > 10) {
        this.$message('文件大小不得超过10M')
        return false
      }
    },
    // 上传
    upload(file) {
      let formData = new FormData()
      formData.append('file', file.file)
      this.importLoading = true
      uploadActCustomer(formData).then(res => {
        this.importLoading = false
        if (res.code === 1) {
          if (res.data == null) {
            this.$message.success('上传成功')
            this.$refs.upload.clearFiles()
            this.uploadDialog = false
            this.errorList = []
          } else {
            this.errorList = res.data
            this.$message.error(res.message)
          }
          this.queryByPage()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 分页
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      if (pageSize != this.pagination.size) this.pagination.current = 1
      this.pagination.size = pageSize
      this.queryByPage()
    },
    // 重置筛选
    resetForm() {
      this.queryCondition = {}
      this.queryByPage(1)
    },
    listSortMethod({ sortList }) {
      let sort = ''
      for (let i = 0; i < sortList.length; i++) {
        if (i !== 0) {
          sort = sort + ','
        }
        sort = sort + sortList[i].field + ' ' + sortList[i].order
      }
      this.sort = sort
      this.queryByPage()
    },
    // 搜索表格数据
    async queryByPage(e) {
      if (e) this.pagination.current = e
      // 筛选条件
      const queryData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        sort: this.sort,
        ...this.queryCondition
      }
      this.listLoading = true // 开启加载动画
      actCustomerfindList(queryData).then(res => {
        if (res.code === 1 && res.data) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          this.listLoading = false
        } else {
          this.$message.error('搜索失败')
        }
      })
    },
    cb() {
      this.showdiv = !this.showdiv
    },
    // 详细信息
    detailFun(row) {
      this.$router.push({ path: `actCustomerDetail/view/${row.id}/${row.seriesCode}` })
    },
    // 删除
    deleteFun(row) {
      this.$confirm('确定删除该记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteActCustomer({ id: row.id }).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
            this.queryByPage()
          } else {
            this.$message.error(res.$message)
          }
        })
      }).catch(() => {})
    },
    // 修改
    editFun(row) {
      this.$router.push({ path: `actCustomerDetail/edit/${row.id}/${row.seriesCode}` })
    }
  }
}
</script>
<style lang="less">
.el-input--medium .el-input__inner {
  height: 30px;
}
.operate {
  display: flex;
  justify-content: space-around;
}
.el-link {
  font-size: 12px;
}
.load-buttom {
  text-decoration: none;
  // float: right;
  height: 30px;
  padding: 0 10px;
  text-align: right;
  line-height: 30px;
  color: #00a7e5;
  display: inline-block;
  font-size: 12px;
}
.load-buttom:hover {
  color: #00b7bf;
}
.err-box {
  margin-top: 10px;
}
.pic-box {
  display: inline-block;
  padding: 5px;
}
.el-input__inner {
  height: 30px!important;
}
</style>
